/**
 * Построение отчёта по накопленному навыку (ТЗ UX-07).
 *
 * Отчёт ничего не меняет: он читает состояние пространства и возвращает его
 * в виде, пригодном для показа. Поэтому здесь нет `Transition` — переходить
 * некуда, экран открывается и закрывается.
 *
 * Контекст расчёта приоритета собирается тем же способом, что и для
 * тренировки: отчёт обязан упорядочивать материал так же, как режим его
 * отбирает, иначе пользователь увидит вверху одно, а получит в занятии
 * другое (docs/ARCHITECTURE.md §5).
 */

import { DEFAULT_LEARNING_CONFIG } from '@type2x/learning-engine';
import type { Workspace } from '@type2x/feature-personal-workspace';
import { activeProfile } from '@type2x/feature-personal-workspace';
import { priorityContext } from '@type2x/feature-adaptive-practice';
import { buildSkillReport, type SkillReport } from '@type2x/feature-progress';

import type { Runtime } from '../runtime.js';
import type { AppScreen } from './app-state.js';

const CONFIG = DEFAULT_LEARNING_CONFIG;

/** Строит отчёт по текущему состоянию активного профиля. */
export function skillReport(runtime: Runtime, workspace: Workspace): SkillReport {
  const profile = activeProfile(workspace);

  return buildSkillReport({
    units: profile.units,
    stats: profile.stats,
    config: CONFIG,
    context: priorityContext(
      {
        language: profile.language,
        layoutId: profile.keyboard.layoutId,
        units: profile.units,
        stats: profile.stats,
        seenInControl: profile.seenInControl,
        leftHandShare: 0.5,
      },
      runtime.clock.epochMs(),
    ),
    now: runtime.clock.isoNow(),
  });
}

/** Экран отчёта со свежим срезом состояния. */
export function reportScreen(runtime: Runtime, workspace: Workspace): AppScreen {
  return { name: 'report', report: skillReport(runtime, workspace) };
}
